import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.js";
import { AuthProvider } from "./context/AuthContext.jsx";

// Pages saved by scripts/prerender.cjs carry the head tags the app injects, marked data-prerender. Remove them before the app
// mounts; it re-adds its own, so nothing is duplicated.
document.querySelectorAll("head [data-prerender]").forEach(el => el.remove());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
